import React from 'react';
import { observer } from 'mobx-react';
import { BannerNoticesIndexWrapper } from '@seedlang/hoc';
import BannerNoticeShow from 'components/banner_notice/banner_notice_show';

@observer
class BannerNoticeIndex extends React.Component {

  render() {
    return (
      <>
        {
          this.props.bannerNotices.map(item => { // filtered in site_serializer
            return (
              <BannerNoticeShow
                key={item.id}
                bannerNotice={item}
              />
            );
          })
        }
      </>
    );
  }
}

export default BannerNoticesIndexWrapper(BannerNoticeIndex);
